module.exports = __webpack_public_path__ + "prod/1.42.2/img/solution6.ae2996f5.png";